"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.widgetStyleBase = exports.widgetDialog = exports.noDialogMask = exports.dialogMask = void 0;
exports.dialogMask = {
    display: "block",
    height: "100vh",
    width: "100vw",
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 10000,
    opacity: 0.5,
    backgroundColor: 'rgba(0,0,0,0.5)',
};
exports.noDialogMask = {
    display: "none",
};
exports.widgetDialog = {
    position: "fixed",
    bottom: 0,
    top: 0,
    left: 0,
    right: 0,
    zIndex: 100000,
    width: "100%",
    height: "95vh",
    border: 0,
};
exports.widgetStyleBase = {
    width: "100%",
    height: "100%",
    border: 0,
};
